module.exports = __webpack_public_path__ + "img/14_9.f157a1ec.png";